
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/faqs",
      function () {
        return require("private-next-pages/help/faqs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/faqs"])
      });
    }
  